<template>
  <div class="menu" @click="close">
    <div class="project-div">
      <div class="project-list">
        <div class="project-item" @click.stop="goPage(1,'home')">
          首页
        </div>
        <div class="project-item" @click.stop="goPage(2,moduleList[0])">
          产品/服务
        </div>
        <div class="project-item2"  @click.stop="goPage(2,item)" v-for="(item,index) in moduleList" :key="index">
          {{item.moduleName}}
        </div>
        <div class="project-item" @click.stop="goPage(1,'contact')">
          联系我们
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productList } from '@/api/index';

export default {
  name: 'MenuView',
  data() {
    return {
      moduleList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      productList().then(res=>{
        this.moduleList = res.data
      })
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.$emit('showMenu', {type:2})
      document.body.style.overflow = '';
    },
    goPage(type,data) {
      if (type == 1) {
        this.$router.push({path: data})
      } else {
        this.$router.push({path: 'product', query: {id: data.id, moduleRouter: data.moduleRouter}})
      }
      this.close()
    }
  }
}
</script>
<style scoped lang="scss">
.menu {
  z-index: 20;
  width:100%;
  height:100%;
  background:rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  .project-div {
    width:540px;
    height:1800px;
    background:#010b21;
    position: absolute;
    right: 0;
    top: 120px;
    .project-list {
      width: 100%;
      height: 100%;
      .project-item {
        width: 100%;
        height: 100px;
        padding: 32px 60px;
        font-family:Source Han Sans CN;
        color:#ffffff;
        font-size:36px;
      }
      .project-item2 {
        width: 100%;
        height: 100px;
        padding: 32px 0px 32px 100px;
        font-family:Source Han Sans CN;
        color:#ffffff;
        font-size:32px;
      }
    }
  }
}

</style>
